export default class PriceHelper {
  static intToPriceString(value: number): string {
    return Number(value / 100).toFixed(2) + " €";
  }
}
